module.exports = __webpack_public_path__ + "img/move.e6422ede.svg";